import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { AgGridReact } from 'ag-grid-react';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

export default class AnalyteResultRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quickFilterText: '',
            result:
                props.data && props.data.results && props.data.results.values && props.data.results.values.length > 0
                    ? 'View All Analytes'
                    : '',
            showPopup: false,
            rowData:
                props.data && props.data.results && props.data.results.values && props.data.results.values.length > 0
                    ? props.data.results.values
                    : [],
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true,
                resizable: true
            },
            columnDefs: [
                {
                    headerName: 'Analyte',
                    minWidth: 80,
                    field: 'analyteName'
                },
                {
                    headerName: 'Result',
                    minWidth: 100,
                    field: 'analyteResult',
                    cellStyle: (params) => {
                        const flag = params.data.analyteFlag;
                        const flagColor = params.data.flagColor;
                        if (flagColor) {
                            return { 
                                color: `#${flagColor}`, 
                                fontWeight: 'bold' 
                            };
                        }
                        // Legacy flag handling
                        if (flag === 'H' || flag === 'L' || flag === 'A') {
                            return { color: '#dc3545', fontWeight: 'bold' };
                        }
                        return null;
                    }
                },
                {
                    headerName: 'Units',
                    minWidth: 100,
                    field: 'analyteUnits'
                },
                {
                    headerName: 'Reference Range',
                    minWidth: 100,
                    field: 'analyteReferenceRange'
                },
                {
                    headerName: 'Flag',
                    minWidth: 100,
                    field: 'analyteFlag',
                    cellStyle: (params) => {
                        const flagColor = params.data.flagColor;
                        if (flagColor) {
                            return { 
                                color: `#${flagColor}`, 
                                fontWeight: 'bold' 
                            };
                        }
                        return null;
                    }
                },
                {
                    headerName: 'Outcome',
                    minWidth: 120,
                    field: 'flagOutcome',
                    cellStyle: (params) => {
                        const outcome = params.value;
                        if (outcome === 'Consistent') {
                            return { 
                                color: '#28a745', 
                                fontWeight: 'bold' 
                            };
                        } else if (outcome === 'Inconsistent') {
                            return { 
                                color: '#dc3545', 
                                fontWeight: 'bold' 
                            };
                        }
                        return null;
                    },
                    valueFormatter: (params) => {
                        return params.value || '';
                    }
                }
            ],
            paginationNumberFormatter: function (params) {
                return '[' + params.value.toLocaleString() + ']';
            }
        };
    }

    handleClose = () => {
        this.setState({ showPopup: false });
    };

    render() {
        return (
            <div>
                <div onClick={() => this.setState({ showPopup: true })} className="cursorPointer">
                    {this.state.result}
                </div>
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showPopup}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Analyte Results</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row form-row">
                            <ThemeContext.Consumer>
                                {({ themeName }) => (
                                    <div
                                        id="currentListGrid"
                                        style={{
                                            height: '400px',
                                            width: '100%',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        <AgGridReact
                                            columnDefs={this.state.columnDefs}
                                            defaultColDef={this.state.defaultColDef}
                                            masterDetail={true}
                                            rowData={this.state.rowData}
                                            pagination={true}
                                            paginationNumberFormatter={this.state.paginationNumberFormatter}
                                            theme={themeName === 'Light' ? themeLight : themeDark}
                                            quickFilterText={this.state.quickFilterText}
                                        />
                                    </div>
                                )}
                            </ThemeContext.Consumer>
                            <div
                                className="col-12"
                                style={{
                                    paddingTop: '12px',
                                    borderTop: '1px solid rgba(0,0,0,0.2)'
                                }}
                            >
                                <Button variant="secondary" style={{ float: 'right' }} onClick={this.handleClose}>
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
